<template>
    <v-card v-ripple="to ? true : false" :flat="flat" class="stat-card" :to="to" :class="{'e-link': !!to, 'card-shadow': !flat, 'bordered': flat}">
        <div class="stat-body d-flex">
            <div class="stat-text flex-grow-1">
                <div class="stat-title details-text strong-text--text">
                    <span class="me-1">
                        <v-icon size="20" :color="color">{{icon}}</v-icon>
                    </span>
                    <span class="me-1">{{label}}</span>
                    <info-tooltip small v-if="info" :text="info" />
                </div>
                <div class="stat-value" :class="{'mt-3': !dense, 'mt-4 mb-1': dense}">
                    <span class="value">{{valueFormat}} </span>
                    <span v-if="unit" class="unit ms-1">{{unit}}</span>
                    <span v-else-if="money" class="unit ms-2">جنيه</span>
                </div>
                <div v-if="!dense" class="small-text muted--text mt-4">
                    <div v-if="typeof(value) === 'object'">
                        <div v-if="value['day']">
                            <span class="font-weight-bold green--text text--darken-1">+{{value['day']}}</span>
                            جديد اليوم منذ منتصف الليل
                        </div>
                        <span v-else>لا يوجد جديد اليوم</span>
                    </div>
                    <div v-else>
                        لا يوجد إحصائيات زمنية أخرى
                    </div>
                </div>

                <div v-if="additionalValue" class="additional-value muted--text details-text mt-1">{{additionalValue}}</div>
            </div>
            <div>
                <!-- <v-btn color="muted" icon style="margin-left: -4px; margin-top: -4px;">
                    <v-icon color="grey">mdi-dots-horizontal</v-icon>
                </v-btn> -->

                <v-menu v-if="typeof(value) === 'object'" close-on-content-click>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text small v-bind="attrs" v-on="on" class="surface2" style="margin-left: -4px; margin-top: -4px;">
                            <v-icon size="18" left class="me-1">mdi-chevron-down</v-icon>
                            <span>{{periods[chosenPeriod].text}}</span>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-subheader>الفترة الزمنية</v-subheader>
                        <v-list-item-group color="primary" v-model="chosenPeriod">
                            <v-list-item :value="periodName" v-for="(period, periodName) in periods" v-show="value && (value[periodName] || value[periodName] === 0)" :key="periodName">
                                <v-list-item-title>{{period.text}}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-menu>
            </div>
            <!-- <v-avatar :class="color + ' lighten-5'" size="50">
                <v-icon size="22" :color="color">{{icon}}</v-icon>
            </v-avatar> -->
            <!-- <div class="stat-icon" :class="statIconClasses">
                <v-icon :size="pcOnly ? 32 : 28" color="white">{{icon}}</v-icon>
            </div> -->
        </div>
        <!-- <div class="stat-footer">
            <div class="d-flex justify-space-between">

            </div>
        </div> -->
    </v-card>
</template>

<script>
import GlobalMethods from '@/helpers/global-methods'
import GlobalComputed from '@/helpers/global-computed'
export default {
    props: {
        label: {
            type: String,
            default: 'Stat',
        },
        to: {

        },
        money: {
            type: Boolean,
            default: false,
        },
        flat: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        value: {

        },
        additionalValue: {
            default: null,
        },
        info: {
            type: String,
            default: null,
        },
        unit: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: 'primary',
        },
        icon: {
            type: String,
            default: 'mdi-shopping',
        },
        textColor: {
            type: String,
            default: 'muted',
        },
        defaultPeriod: {
            type: String,
        }
    },
    data(){
        return {
            chosenPeriod: 'all',

            periods: {
                'all': {text: 'الكل'},
                'day': {text: 'اليوم'},
                'yesterday': {text: 'اﻷمس'},
                'week': {text: 'اﻷسبوع الحالي'},
                'last_week': {text: 'اﻷسبوع الماضي'},
                'month': {text: 'الشهر الحالي'},
                'last_month': {text: 'الشهر الماضي'},
                '3-months': {text: 'آخر 3 أشهر'},
                '6-months': {text: 'آخر 6 أشهر'},
                'year': {text: 'العام الحالي'},
                'last_year': {text: 'العام الماضي'},
            }
        }
    },
    computed: {
        colorName(){
            return this.color.split(' ')[0];
        },
        valueFormat(){
            if (!this.value && this.value !== 0){
                return '';
            }
            const value = typeof(this.value) === 'object' ? this.value[this.chosenPeriod] : this.value;
            return this.money ? this.moneyFormat(value) : this.numFormat(value);
        },
        statIconClasses(){
            const colorName = this.color;
            return `${colorName}`;
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    },
    mounted(){
        if (this.defaultPeriod){
            this.chosenPeriod = this.defaultPeriod;
        }
    }
}
</script>

<style lang="scss" scoped>
    .v-card.stat-card{
        height: 100%;
        border-radius: 3px!important;
        @media(max-width: 756px){
            border-radius: 0!important;
        }
        transition: all 0.15s ease-in-out, background 0s;
        // cursor: default;
        user-select: none;
        &.v-card--link:focus:before{
            opacity: 0;
        }
        .stat-body{
            padding: 1.2rem 1.4rem;
        }
        .stat-footer{
            border-top: 1px solid hsla(0, 0, 50%, 0.15);
            padding: 4px;
        }
        .stat-icon{
            min-height: 52px;
            height: 52px;
            min-width: 52px;
            width: 52px;

            border-radius: 5px;
            overflow: hidden;

            display: flex;
            justify-content: center;
            align-items: center;
        }
        .stat-text{
            user-select: text;
            .stat-title{
                font-weight: 500!important;
                color: rgba(#fff, 0.75);
                line-height: 1.1rem;
            }
        }
        .stat-value{
            display: flex;
            align-items: center;
            line-height: 1.1rem;
            font-size: 1.4rem!important;
            .value{
                font-weight: 900;
                letter-spacing: 0.5px;
                // text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2)
            }
            .unit{
                font-weight: 500;
                font-size: 1.1rem;
            }
        }
    }

</style>
